var _path, _circle, _circle2, _circle3, _circle4, _rect, _path2, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 52 L132 66 M92 103 L132 84 M208 52 L168 66 M208 103 L168 84",
    stroke: "#FDBA74",
    strokeWidth: 1.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 50,
    r: 12,
    fill: "#FFF7ED",
    stroke: "#F97316",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 105,
    r: 12,
    fill: "#FFF7ED",
    stroke: "#F97316",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 50,
    r: 12,
    fill: "#FFF7ED",
    stroke: "#F97316",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 105,
    r: 12,
    fill: "#FFF7ED",
    stroke: "#F97316",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 58,
    width: 36,
    height: 34,
    rx: 6,
    fill: "#fff",
    stroke: "#F59E0B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 58 v-6 a10 10 0 0 1 20 0 v6",
    fill: "none",
    stroke: "#F59E0B",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 74,
    r: 4,
    fill: "#F59E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.960af9d713ac4f7eb608a47e1ffb0d86.svg";
export { ForwardRef as ReactComponent };